import { AdminMatches } from '@platform/client';
import { useParams } from 'wouter';
import { useState } from 'react';
import { AdminDetailPage } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';
import { UpdatesTabContent } from './UpdatesTabContent';
import { MatchEmailTabContent } from './EmailTabContent';
import { ProjectPlanTabContent } from './ProjectPlanTabContent';
import { UpdateProgressModal } from './UpdateProgressModal';

export const MatchDetail = () => {
  const { matchGroupId } = useParams<{ matchGroupId: string }>();
  const [editProgressModalOpen, setEditProgressModalOpen] = useState(false);
  const {
    data: matchData,
    isLoading,
    isSuccess,
  } = AdminMatches.useGetAdminMatchById(parseInt(matchGroupId));
  return (
    <>
      <AdminDetailPage
        title={matchData?.matchGroup?.id ? `Match #${matchData?.matchGroup?.id}` : 'Match Details'}
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          {
            id: 'Details',
            content: (
              <DetailsTabContent
                matchData={matchData?.matchGroup}
                recentDiscoveryUpdate={matchData?.matchUpdates?.discoveryUpdates?.[0]}
                recentPlanUpdate={
                  matchData?.matchUpdates?.planUpdates?.filter(
                    (update) => update.outcome !== 'complete',
                  )[0]
                }
                recentActionUpdate={matchData?.matchUpdates?.actionUpdates?.[0]}
                proPlanBriefSubmittedAt={matchData?.planProBriefSubmittedAt}
                orgPlanBriefSubmittedAt={matchData?.planOrgBriefSubmittedAt}
                onCallSubmittedAt={matchData?.planOnCallSubmittedAt}
              />
            ),
          },
          {
            id: 'Updates',
            content: (
              <UpdatesTabContent
                discoveryUpdates={matchData?.matchUpdates?.discoveryUpdates}
                planUpdates={matchData?.matchUpdates?.planUpdates}
                actionUpdates={matchData?.matchUpdates?.actionUpdates}
              />
            ),
          },
          {
            id: 'Project Plan',
            content: (
              <ProjectPlanTabContent
                matchGroupId={matchData?.matchGroup?.id ?? 0}
                actionUpdates={matchData?.matchUpdates?.actionUpdates}
              />
            ),
          },
          {
            id: 'Emails',
            content: <MatchEmailTabContent matchGroupId={parseInt(matchGroupId)} />,
          },
        ]}
        pageActions={[
          {
            text: 'Edit Progress',
            type: 'button',
            onPress: () => setEditProgressModalOpen(true),
          },
        ]}
      />
      {editProgressModalOpen && (
        <UpdateProgressModal
          isTeam={!!matchData?.matchGroup?.team_id}
          matchGroupId={parseInt(matchGroupId)}
          onClose={() => setEditProgressModalOpen(false)}
        />
      )}
    </>
  );
};
